import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { Process } from '../components/Process';
import { CTA } from '../components/CTA';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-emerald-200 selection:text-emerald-900" data-id="element-160">
      <Header data-id="element-161" />
      <main data-id="element-162">
        <Hero data-id="element-163" />
        <About data-id="element-164" />
        <Services data-id="element-165" />
        <WhyUs data-id="element-166" />
        <Process data-id="element-167" />
        <CTA data-id="element-168" />
      </main>
      <Footer data-id="element-169" />
    </div>;
}